import React, { useEffect, useState, useRef, useContext } from 'react';
import { Row, Col, Tooltip, } from 'reactstrap';
import DayTime from '../../../common/DayTimeWrapper'
import { CBCTypeId, defaultPageSize, EMPTY_DATA, EXCHNAGERATE, RMDOMESTIC, RMIMPORT, BOPIMPORT, ZBCTypeId } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId, searchNocontentFilter, IsShowFreightAndShearingCostFields } from '../../../../helper';
import Toaster from '../../../common/Toaster';
import { runVerifySimulation } from '../../actions/Simulation';
import { Fragment } from 'react';
import { TextFieldHookForm } from '../../../layout/HookFormInputs';
import DatePicker from "react-datepicker";
import { useForm, Controller } from 'react-hook-form'
import RunSimulationDrawer from '../RunSimulationDrawer';
import VerifySimulation from '../VerifySimulation';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import _, { debounce } from 'lodash'
import { VBC, ZBC } from '../../../../config/constants';
import { PaginationWrapper } from '../../../common/commonPagination';
import WarningMessage from '../../../common/WarningMessage';
import { getMaxDate } from '../../SimulationUtils';
import PopupMsgWrapper from '../../../common/PopupMsgWrapper';
import { APPLICABILITY_RM_SIMULATION, FORGING, RM_IMPACT_DOWNLOAD_EXCEl, RM_IMPACT_DOWNLOAD_EXCEl_IMPORT } from '../../../../config/masterData';
import ReactExport from 'react-export-excel';
import { createMultipleExchangeRate } from '../../../masters/actions/ExchangeRateMaster';
import LoaderCustom from '../../../common/LoaderCustom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { simulationContext } from '..';
import { useLabels } from '../../../../helper/core';
import AddOtherCostDrawer from '../../../masters/material-master/AddOtherCostDrawer';
import { setCommodityDetails } from '../../../masters/actions/Indexation';
import AddConditionCosting from '../../../costing/components/CostingHeadCosts/AdditionalOtherCost/AddConditionCosting';
import { hideColumnFromExcel, parsedDate, updateCostValue } from '../../../common/CommonFunctions';

const gridOptions = {

};

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function RMSimulation(props) {
    const { showEditMaster, handleEditMasterPage, showCompressedColumns, render } = useContext(simulationContext) || {};

    const { list, isbulkUpload, rowCount, technology, master, isImpactedMaster, costingAndPartNo, tokenForMultiSimulation, technologyId, isCostingSimulation } = props

    const [showRunSimulationDrawer, setShowRunSimulationDrawer] = useState(false)
    const [showverifyPage, setShowVerifyPage] = useState(false)
    const [token, setToken] = useState('')
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [textFilterSearch, setTextFilterSearch] = useState('')
    const [isDisable, setIsDisable] = useState(false)
    const [effectiveDate, setEffectiveDate] = useState('');
    const [maxDate, setMaxDate] = useState('');
    const [isEffectiveDateSelected, setIsEffectiveDateSelected] = useState(false);
    const [isWarningMessageShow, setIsWarningMessageShow] = useState(false)
    const [titleObj, setTitleObj] = useState({})
    const [showPopup, setShowPopup] = useState(false)
    const [popupMessage, setPopupMessage] = useState('There is no changes in scrap rate Do you want to continue')
    const gridRef = useRef();
    const [noData, setNoData] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false)
    const [basicRateviewTooltip, setBasicRateViewTooltip] = useState(false)
    const [scrapRateviewTooltip, setScrapRateViewTooltip] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [isScrapUOMApplyTemp, setIsScrapUOMApplyTemp] = useState(false)
    const [openOtherCostDrawer, setOpenOtherCostDrawer] = useState(false)
    const [openConditionCostDrawer, setOpenConditionCostDrawer] = useState(false)
    const [otherCostDetailForRow, setOtherCostDetailForRow] = useState([])

    const [conditionCostDetailForRow, setConditionCostDetailForRow] = useState([])
    const [isViewFlag, setIsViewFlag] = useState(false)
    const [rowData, setRowData] = useState([])
    const [basicRate, setBasicRate] = useState('')
    const [netCostWithoutConditionCost, setNetCostWithoutConditionCost] = useState('')

    const [rowIndex, setRowIndex] = useState('')
    const [editIndex, setEditIndex] = useState('')
    const { register, control, setValue, getValues, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })

    const { technologyLabel, vendorLabel } = useLabels();
    const dispatch = useDispatch()

    const currencySelectList = useSelector(state => state.comman.currencySelectList)
    const { selectedMasterForSimulation, exchangeRateListBeforeDraft } = useSelector(state => state.simulation)
    const simulationApplicability = useSelector(state => state.simulation.simulationApplicability)

    const masterList = useSelector(state => state.simulation.masterSelectListSimulation)
    const { filteredRMData } = useSelector(state => state.material)
    const columnWidths = {
        CostingHead: showCompressedColumns ? 50 : 140,
        VendorCode: showCompressedColumns ? 50 : 160,
        RawMaterialName: showCompressedColumns ? 50 : 160,
        RawMaterialGradeName: showCompressedColumns ? 50 : 120,
        RawMaterialSpecificationName: showCompressedColumns ? 50 : 140,
        RawMaterialCode: showCompressedColumns ? 50 : 135,
        Category: showCompressedColumns ? 50 : 110,
        TechnologyName: showCompressedColumns ? 50 : 125,
        CustomerName: showCompressedColumns ? 50 : 160,
        PlantCode: showCompressedColumns ? 50 : 160,
        UnitOfMeasurementName: showCompressedColumns ? 50 : 100,
        CostingNumber: showCompressedColumns ? 50 : 190,
        PartNumber: showCompressedColumns ? 50 : 190,
        RMFreightCost: showCompressedColumns ? 50 : 150,
        RMShearingCost: showCompressedColumns ? 50 : 170,
        MachiningScrapRate: showCompressedColumns ? 50 : 170,
        EffectiveDate: showCompressedColumns ? 50 : 140,
        OldRMNetLandedCostConversion: showCompressedColumns ? 70 : 120,
        NewRMNetLandedCostConversion: showCompressedColumns ? 70 : 120,
        ScrapRatePerScrapUOM: showCompressedColumns ? 70 : 120,
        NewScrapRatePerScrapUOM: showCompressedColumns ? 70 : 120,
        NewNetCostWithoutConditionCost: showCompressedColumns ? 70 : 120,
        NetCostWithoutConditionCost: showCompressedColumns ? 70 : 120
    };
    useEffect(() => {
        if (isbulkUpload) {
            setValue('NoOfCorrectRow', rowCount.correctRow)
            setValue('NoOfRowsWithoutChange', rowCount.NoOfRowsWithoutChange)
            setTitleObj(prevState => ({ ...prevState, rowWithChanges: rowCount.correctRow, rowWithoutChanges: rowCount.NoOfRowsWithoutChange }))
        }
        setIsLoader(true)
        let scrapUOMApplyList = _.map(list, 'IsScrapUOMApply')
        setTimeout(() => {
            if (scrapUOMApplyList?.includes("Yes") || scrapUOMApplyList?.includes(true)) {
                setIsScrapUOMApplyTemp(true)
                setIsLoader(false)
            } else {
                setIsScrapUOMApplyTemp(false)
                setIsLoader(false)
            }
        }, 200);
        if (!isImpactedMaster && !isbulkUpload) {
            list && list?.map(item => {
                item.NewBasicRate = item.BasicRatePerUOM
                item.NewScrapRatePerScrapUOM = item.ScrapRatePerScrapUOM
                item.NewOtherNetCost = item.OtherNetCost
                item.NewNetConditionCost = item.NetConditionCost  // ADD KEY FROM API
                item.NewNetCostWithoutConditionCost = item.NetCostWithoutConditionCost
                item.NewRawMaterialOtherCostDetails = item.RawMaterialOtherCostDetails || []; // Set to existing data or empty array
                item.NewRawMaterialConditionCostDetails = item.RawMaterialConditionsDetails || []; // Set to existing data or empty array
                setNetCostWithoutConditionCost(item.NewNetCostWithoutConditionCost)
            })
        }
    }, [])

    useEffect(() => {
        if (list && list?.[rowIndex] && !isImpactedMaster) {
            let obj = list?.[rowIndex]
            obj.otherCostTableData = obj.NewRawMaterialOtherCostDetails
            obj.conditionTableData = obj.NewRawMaterialConditionCostDetails
            const updatedObjOtherCost = updateCostValue(false, obj, basicRate, true)
            obj.NewRawMaterialOtherCostDetails = updatedObjOtherCost?.tableData

            obj.NewOtherNetCost = updatedObjOtherCost?.formValue?.value
            obj.NewOtherNetCostConversion = updatedObjOtherCost?.formValue?.value
            obj.NewOtherNetCostLocalConversion = updatedObjOtherCost?.formValue?.value


            const basicPrice = checkForNull(basicRate) + checkForNull(updatedObjOtherCost?.formValue?.value)

            const updatedObjConditionCost = updateCostValue(true, obj, basicPrice, true)
            obj.NewRawMaterialConditionCostDetails = updatedObjConditionCost?.tableData


            obj.NewNetConditionCost = updatedObjConditionCost?.formValue?.value
            obj.NewConditionNetCostConversion = updatedObjConditionCost?.formValue?.value
            obj.NewConditionNetCostLocalConversion = updatedObjConditionCost?.formValue?.value


            obj.NewNetLandedCost = checkForNull(basicRate) + checkForNull(updatedObjOtherCost?.formValue?.value) + checkForNull(updatedObjConditionCost?.formValue?.value)
            obj.NewNetCostWithoutConditionCost = checkForNull(basicRate) + checkForNull(updatedObjOtherCost?.formValue?.value)
            obj.NewNetLandedCostConversion = checkForNull(basicRate) + checkForNull(updatedObjOtherCost?.formValue?.value) + checkForNull(updatedObjConditionCost?.formValue?.value)
            obj.NewNetLandedCostLocalConversion = checkForNull(basicRate) + checkForNull(updatedObjOtherCost?.formValue?.value) + checkForNull(updatedObjConditionCost?.formValue?.value)

            setNetCostWithoutConditionCost(obj.NewNetCostWithoutConditionCost)
            list[rowIndex] = obj


            setIsLoader(true)
            setTimeout(() => {
                setIsLoader(false)
            }, 200);
        }
    }, [basicRate, openOtherCostDrawer, openConditionCostDrawer, otherCostDetailForRow, list])

    useEffect(() => {

        if (handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, showverifyPage)
        }
    }, [showverifyPage])
    useEffect(() => {
        if (list && list.length > 0) {
            window.screen.width >= 1921 && gridRef.current.api.sizeColumnsToFit();
            let tempList = [...list]
            if (simulationApplicability?.value === APPLICABILITY_RM_SIMULATION) {
                tempList = [...exchangeRateListBeforeDraft]
            }
            let maxDate = getMaxDate(tempList)
            setMaxDate(parsedDate(maxDate?.EffectiveDate));
        }
    }, [list])

    const setValueFunction = (check, tempList = []) => {
        /**********POST METHOD TO CALL HERE AND AND SEND TOKEN TO VERIFY PAGE TODO ****************/
        const filteredMasterId = masterList?.find(item => item?.Text === "RM Import")?.Value;
        let obj = {
            IsExchangeRateSimulation: check,
            SimulationRawMaterials: [],
            SimulationExchangeRates: [],
            SimulationIds: [],
            TechnologyId: technologyId,
            SimulationTechnologyId: check ? EXCHNAGERATE : selectedMasterForSimulation.value,
            //EffectiveDate: DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss'),
            LoggedInUserId: loggedInUserId(),
            SimulationHeadId: list[0]?.CostingTypeId,
            IsSimulationWithOutCosting: false,
            ExchangeRateSimulationTechnologyId: filteredMasterId
        };

        if (filteredRMData.plantId && filteredRMData.plantId.value) {
            obj.PlantId = filteredRMData.plantId ? filteredRMData.plantId.value : ''
        }
        let tempArr = []
        if (String(selectedMasterForSimulation.value) === String(RMDOMESTIC) || String(selectedMasterForSimulation.value) === String(RMIMPORT) || String(selectedMasterForSimulation.value) === String(EXCHNAGERATE)) {
            list && list.map(item => {
                if ((item.NewBasicRate !== undefined || item.NewScrapRate !== undefined || item.NewBasicrateFromPercentage) && ((item.NewBasicRate !== undefined || item.NewBasicrateFromPercentage) ? Number(item.NewBasicRate) : (Number(item.BasicRate)) !== Number(item.BasicRatePerUOM) || ((item.NewScrapRate !== undefined || item.NewBasicrateFromPercentage) ? Number(item.NewScrapRate) : Number(item.ScrapRate)) !== Number(item.ScrapRate))) {
                    let tempObj = {
                        IsAppliedChanges: true,
                        CostingHead: item.CostingHead === 'Vendor Based' ? VBC : ZBC,
                        RawMaterialId: item.RawMaterialId,
                        NewRawMaterialId: item.NewRawMaterialId ? item.NewRawMaterialId : null,
                        PlantId: item.PlantId,
                        RawMaterialName: item.RawMaterialName,
                        RawMaterialGrade: item.RawMaterialGradeName,
                        RawMaterialSpecification: item.RawMaterialSpecificationName,
                        MaterialType: item.MaterialType,
                        RawMaterialCategory: item.Category,
                        RawMaterialEntryType: item.RawMaterialEntryType || 0, // Assuming a default value
                        UOM: item.UnitOfMeasurementName,
                        OldBasicRate: isbulkUpload ? item.BasicRate : item.BasicRatePerUOM,
                        NewBasicRate: item.NewBasicRate ? item.NewBasicRate : item.NewBasicrateFromPercentage ? item.NewBasicrateFromPercentage : item.BasicRate,
                        OldScrapRate: item.ScrapRate,
                        NewScrapRate: item.NewScrapRate ? item.NewScrapRate : item.ScrapRate,
                        RawMaterialFreightCost: checkForNull(item.RMFreightCost),
                        RawMaterialShearingCost: checkForNull(item.RMShearingCost),
                        OldNetLandedCost: item.NetLandedCost,
                        NewNetLandedCost: Number(item.NewBasicRate ? item.NewBasicRate : item.BasicRate) + (getConfigurationKey().IsShowFreightAndShearingCostFields ? checkForNull(item.RMShearingCost) + checkForNull(item.RMFreightCost) : 0) + checkForNull(item.NewNetConditionCost) + checkForNull(item.NewOtherNetCost),
                        EffectiveDate: item.EffectiveDate,
                        VendorId: item.VendorId,
                        Delta: 0,
                        OldScrapRatePerScrapUOM: item.ScrapRatePerScrapUOM,
                        NewScrapRatePerScrapUOM: item.NewScrapRatePerScrapUOM,
                        NewNetConditionCost: item.NewNetConditionCost || 0,
                        NewOtherNetCost: item.NewOtherNetCost || 0,
                        NewNetCostWithoutConditionCost: Number(item.NewBasicRate ? item.NewBasicRate : item.BasicRate) + checkForNull(item.NewOtherNetCost) || 0,
                        RawMaterialConditionsDetails: item.NewRawMaterialConditionCostDetails || [],
                        RawMaterialOtherCostDetails: item.NewRawMaterialOtherCostDetails || []
                    };
                    tempArr.push(tempObj);
                }
                return null;
            });
        } else {
            list && list.map(item => {
                let tempObj = {}
                tempObj.CostingHead = item.CostingHead === 'Vendor Based' ? VBC : ZBC
                tempObj.RawMaterialName = item.RawMaterialName
                tempObj.MaterialType = item.MaterialType
                tempObj.RawMaterialGrade = item.RawMaterialGradeName
                tempObj.RawMaterialSpecification = item.RawMaterialSpecificationName
                tempObj.RawMaterialCategory = item.Category
                tempObj.UOM = item.UnitOfMeasurementName
                tempObj.OldBasicRate = isbulkUpload ? item.BasicRate : item.BasicRatePerUOM
                tempObj.NewBasicRate = item.NewBasicRate ? item.NewBasicRate : (item.NewBasicrateFromPercentage !== 0 && item.NewBasicrateFromPercentage !== null && item.NewBasicrateFromPercentage !== undefined) ? item.NewBasicrateFromPercentage : (isbulkUpload ? item.BasicRate : item.BasicRatePerUOM)
                tempObj.OldScrapRate = item.ScrapRate
                tempObj.NewScrapRate = item.NewScrapRate ? item.NewScrapRate : item.ScrapRate
                tempObj.RawMaterialFreightCost = checkForNull(item.RMFreightCost)
                tempObj.RawMaterialShearingCost = checkForNull(item.RMShearingCost)
                tempObj.OldNetLandedCost = item.NetLandedCost
                tempObj.NewNetLandedCost = Number(item.NewBasicRate ? item.NewBasicRate : item.BasicRate) + (getConfigurationKey().IsShowFreightAndShearingCostFields ? checkForNull(item.RMShearingCost) + checkForNull(item.RMFreightCost) : 0)
                tempObj.NewNetCostWithoutConditionCost = Number(item.NewBasicRate ? item.NewBasicRate : item.BasicRate) + checkForNull(item.NewOtherNetCost)
                tempObj.EffectiveDate = item.EffectiveDate
                tempObj.RawMaterialId = item.RawMaterialId
                tempObj.PlantId = item.PlantId
                tempObj.VendorId = item.VendorId
                tempObj.Delta = 0
                tempObj.OldScrapRatePerScrapUOM = item.ScrapRatePerScrapUOM
                tempObj.NewScrapRatePerScrapUOM = item.NewScrapRatePerScrapUOM
                tempObj.NewNetConditionCost = item.NewNetConditionCost || 0
                tempObj.NewOtherNetCost = item.NewOtherNetCost || 0
                tempObj.RawMaterialConditionsDetails = item.NewRawMaterialConditionCostDetails || []
                tempObj.RawMaterialOtherCostDetails = item.NewRawMaterialOtherCostDetails || []

                tempArr.push(tempObj)

                return null;
            })
        }


        obj.SimulationIds = tokenForMultiSimulation
        obj.SimulationRawMaterials = tempArr
        if (check) {
            obj.SimulationExchangeRates = tempList
            obj.IsExchangeRateSimulation = true
        }

        obj.EffectiveDate = DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss')
        dispatch(runVerifySimulation(obj, res => {
            setIsDisable(false)

            if (res?.data?.Result) {
                setToken(res?.data?.Identity)
                setShowVerifyPage(true)
            }
        }))
    }

    const verifySimulation = debounce(() => {
        if (!isEffectiveDateSelected) {
            setIsWarningMessageShow(true)
            return false
        }
        let netLandedCostChangeCount = 0
        let isScrapRateGreaterThanBasiRate = false
        let scrapRateChangeArr = [];
        let basicRateZeroCount = 0
        list && list.map((li) => {
            const oldNetLandedCost = Number(li.NetLandedCost)
            const newNetLandedCost = Number(checkForNull(li?.NewBasicRate || li?.BasicRatePerUOM) +
                checkForNull(li?.NewOtherNetCost) +
                (getConfigurationKey().IsShowFreightAndShearingCostFields ? checkForNull(li?.RMFreightCost) + checkForNull(li?.RMShearingCost) : 0) +
                checkForNull(li?.NewNetConditionCost))

            if (oldNetLandedCost === newNetLandedCost) {
                netLandedCostChangeCount = netLandedCostChangeCount + 1
            }
            if (oldNetLandedCost !== newNetLandedCost &&
                (Number(li.ScrapRate) === Number(li?.NewScrapRate || li.ScrapRate))) {
                scrapRateChangeArr.push(li)
            }
            if (li.NewBasicrateFromPercentage === undefined ||
                li?.NewBasicrateFromPercentage < (li?.NewScrapRate === undefined || li?.NewScrapRate === '' ?
                    Number(li?.ScrapRate) : Number(li?.NewScrapRate))) {
                if ((li?.NewBasicRate === undefined || li?.NewBasicRate === '' ?
                    Number(li?.BasicRatePerUOM) : Number(li?.NewBasicRate)) <
                    (li?.NewScrapRate === undefined || li?.NewScrapRate === '' ?
                        Number(li?.ScrapRate) : Number(li?.NewScrapRate))) {
                    isScrapRateGreaterThanBasiRate = true
                }
                if (isScrapRateGreaterThanBasiRate && !(Number(netLandedCostChangeCount) === Number(list.length))) {
                    li.NewBasicRate = li?.BasicRatePerUOM
                    li.NewScrapRate = li?.ScrapRate
                    Toaster.warning('Scrap Rate should be less than Basic Rate')
                    return false
                }
            }
            if (checkForNull(li?.NewBasicRate) === 0) {
                basicRateZeroCount = basicRateZeroCount + 1
            }
            return null;
        })

        if ((selectedMasterForSimulation?.value === RMDOMESTIC || selectedMasterForSimulation?.value === RMIMPORT) &&
            netLandedCostChangeCount === list.length) {
            Toaster.warning('There is no changes in net cost. Please make changes to run simulation')
            return false
        }
        if (basicRateZeroCount > 0) {
            Toaster.warning('Basic Rate should not be zero')
            return false
        }
        if (scrapRateChangeArr.length !== 0) {
            let rmName = []
            scrapRateChangeArr.map(item => rmName.push(item.RawMaterialCode))
            let rmNameString = rmName.join(', ')
            setPopupMessage(`Scrap rate is not changed for some raw material (${rmNameString}). Do you still wish to continue?`)
            setShowPopup(true)
            setShowTooltip(false)
            return false
        }
        setIsDisable(true)

        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, effectiveDate, res => {
                if (!res?.status && !res?.error) {
                    setValueFunction(true, res);
                }
            }))
        } else {
            setValueFunction(false, []);
        }
        setShowTooltip(false)
    }, 600)

    const cancelVerifyPage = () => {

        setShowVerifyPage(false)
    }
    const resetState = () => {
        gridApi?.setQuickFilter('');
        setTextFilterSearch('')
        gridOptions?.columnApi?.resetColumnState();
        gridOptions?.api?.setFilterModel(null);
        window.screen.width >= 1921 && gridRef.current.api.sizeColumnsToFit();
    }

    /**
     * @method shearingCostFormatter
     * @description Renders buttons
     */
    const CostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        return cell != null ? cell : '-';
    }

    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (list.length !== 0) {
                setNoData(searchNocontentFilter(value, noData))
            }
        }, 500);
    }
    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell != null ? <span title={DayTime(cell).format('DD/MM/YYYY')}> {cell.includes("T") ? DayTime(cell).format('DD/MM/YYYY') : cell}</span> : '';
    }


    const costingHeadFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell ? cell : '-';
    }
    const vendorFormatter = (props) => {
        return (<span title={isbulkUpload ? props?.value : props?.data.VendorName}>{isbulkUpload ? props?.value : props?.data.VendorName}</span>);
    }

    const customerFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (<span title={isbulkUpload ? row['Customer (Code)'] : row?.CustomerName}>{isbulkUpload ? row['Customer (Code)'] : row?.CustomerName}</span>);
    }

    const plantFormatter = (props) => {
        return (<span title={isbulkUpload ? props?.value : props?.data.DestinationPlantName}>{isbulkUpload ? props?.value : props?.data.DestinationPlantName}</span>);
    }
    const newBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell, props, "basicRate")
        
        // Calculate display value with clear priority
        let displayValue = 0;
        
        // Always prioritize percentage calculation when percentage exists
        if (row?.Percentage && Number(row?.Percentage) !== 0) {
            const originalBasicRate = Number(row?.BasicRatePerUOM || 0);
            displayValue = originalBasicRate + (originalBasicRate * Number(row?.Percentage) / 100);
        }
        // Priority 2: Use NewBasicRate if it exists (from manual entry when no percentage)
        else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            displayValue = Number(row?.NewBasicRate);
        }
        // Priority 3: Use manual cell entry
        else if (cell && value) {
            displayValue = Number(cell);
        }
        // Priority 4: Use original basic rate
        else {
            displayValue = Number(row?.BasicRatePerUOM || 0);
        }
        

        
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewBasicRate, getConfigurationKey().NoOfDecimalForPrice) :
                        <span id={`newBasicRate-${props.rowIndex}`} className={`form-control ${row?.Percentage && Number(row?.Percentage) !== 0 ? 'percentage-applied' : ''} basicRate_revised`} title={displayValue}>
                            {checkForDecimalAndNull(displayValue, getConfigurationKey().NoOfDecimalForPrice)}
                        </span>
                }

            </>
        )
    }

    const oldBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        row?.OldBasicRate :
                        <span title={cell && value ? Number(cell) : Number(row?.BasicRatePerUOM)}>{cell && value ? Number(cell) : Number(row?.BasicRatePerUOM)} </span>
                }

            </>
        )
    }

    const newScrapRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell, props, "scrapRate")
        
        // Calculate display value with percentage logic (similar to basic rate)
        let displayValue = 0;
        
        // Priority 1: If percentage exists, calculate scrap rate with percentage
        if (row?.Percentage && Number(row?.Percentage) !== 0) {
            const originalScrapRate = Number(row?.ScrapRate || 0);
            displayValue = originalScrapRate + (originalScrapRate * Number(row?.Percentage) / 100);
        }
        // Priority 2: Use NewScrapRate if it exists (from manual entry when no percentage)
        else if (row?.NewScrapRate && Number(row?.NewScrapRate) !== 0) {
            displayValue = Number(row?.NewScrapRate);
        }
        // Priority 3: Use manual cell entry
        else if (cell && value) {
            displayValue = Number(checkForNull(cell));
        }
        // Priority 4: Use original scrap rate
        else {
            displayValue = Number(checkForNull(row?.ScrapRate));
        }
        

        
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewScrapRate, getConfigurationKey().NoOfDecimalForPrice) :
                        <span id={`newScrapRate-${props.rowIndex}`} className={`form-control ${row?.IsScrapUOMApply === 'Yes' ? 'disabled' : ''} ${row?.Percentage && Number(row?.Percentage) !== 0 ? 'percentage-applied' : ''}`} title={displayValue}>
                            {checkForDecimalAndNull(displayValue, getConfigurationKey().NoOfDecimalForPrice)}
                        </span>
                }
            </>
        )
    }
    const newScrapRateUOMFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const newScrapRateInOldUOM = checkForDecimalAndNull(cell * row?.CalculatedFactor, getConfigurationKey().NoOfDecimalForPrice)
        const value = beforeSaveCell(newScrapRateInOldUOM, props, "scrapRate")
        if (value && !isImpactedMaster) {
            row.NewScrapRate = newScrapRateInOldUOM
            row.NewScrapRatePerScrapUOM = cell
        }
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewScrapRatePerScrapUOM, getConfigurationKey().NoOfDecimalForPrice) :
                        <span id={`newScrapRate-${props.rowIndex}`} className={`form-control ${row?.IsScrapUOMApply === 'No' ? 'disabled' : ''}`} title={cell && value ? Number(checkForNull(cell)) : Number(checkForNull(row?.ScrapRatePerScrapUOM))}>{cell && value ? Number(checkForNull(cell)) : Number(checkForNull(row?.ScrapRatePerScrapUOM))}</span>
                }
            </>
        )
    }

    const oldScrapRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        row?.OldScrapRate :
                        <span title={cell && value ? checkForNull(Number(cell)) : checkForNull(Number(row?.ScrapRate))}>{cell && value ? checkForNull(Number(cell)) : checkForNull(Number(row?.ScrapRate))}</span>
                }
            </>
        )
    }

    const oldScrapRateFormatterPerScrapUOM = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForNull(row?.OldScrapRatePerScrapUOM) :
                        <span title={cell && value ? checkForNull(Number(cell)) : Number(checkForNull(row?.ScrapRate))}>{cell && value ? checkForNull(Number(cell)) : checkForNull(Number(checkForNull(row?.ScrapRate)))}</span>
                }
            </>
        )
    }

    // const colorCheck = 

    const costFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return isImpactedMaster ? checkForDecimalAndNull(row?.OldNetLandedCost, getConfigurationKey().NoOfDecimalForPrice) : checkForDecimalAndNull(cell, getConfigurationKey().NoOfDecimalForPrice)
    }

    /**
  * @method beforeSaveCell
  * @description CHECK FOR ENTER NUMBER IN CELL
  */
    const beforeSaveCell = (cell, props, type) => {
        const cellValue = cell
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        if ((row?.NewBasicRate === undefined || row?.NewBasicRate === '' ? Number(row?.BasicRatePerUOM) : Number(row?.NewBasicRate)) <
            (row?.NewScrapRate === undefined || row?.NewScrapRate === '' ? Number(row?.ScrapRate) : Number(row?.NewScrapRate))) {
            if (type === "basicRate") {
                row.NewBasicRate = row?.BasicRatePerUOM
            } else if (type === "scrapRate") {
                row.NewScrapRate = row?.ScrapRate
            }
            Toaster.warning('Scrap Rate should be less than Basic Rate')
            return false
        }
        if (Number.isInteger(Number(cellValue)) && /^\+?(0|[1-9]\d*)$/.test(cellValue) && cellValue.toString().replace(/\s/g, '').length) {
            if (cellValue.length > 8) {
                Toaster.warning("Value should not be more than 8")
                return false
            }
            return true
        } else if (cellValue && !/^[+]?([0-9]+(?:[.][0-9]*)?|\.[0-9]+)$/.test(cellValue)) {
            Toaster.warning('Please enter a valid positive numbers.')
            if (type === "Percentage") {
                row.Percentage = 0
            }
            if (type === "basicRate") {
                row.NewBasicRate = row?.BasicRatePerUOM
            } else if (type === "scrapRate") {
                row.NewScrapRate = row?.ScrapRate
            }
            return false
        }

        return true
    }

    const showValue = (row, classGreen, newBasicRate) => {

        let value = checkForDecimalAndNull(isImpactedMaster ? row?.NewNetLandedCost : checkForNull(newBasicRate) + checkForNull(row?.NewOtherNetCost) + checkForNull(row?.NewNetConditionCost), getConfigurationKey().NoOfDecimalForPrice)
        return <span className={classGreen} title={checkForDecimalAndNull(isImpactedMaster ? row?.NewNetLandedCost : checkForNull(newBasicRate) + checkForNull(row?.NewOtherNetCost) + checkForNull(row?.NewNetConditionCost), getConfigurationKey().NoOfDecimalForPrice)}>{value}</span>
    }

    const NewcostFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        if (isbulkUpload) {
            const revisedCost = checkForNull(row?.NewBasicRate);
            const existingCost = checkForNull(row?.NetLandedCost);
            const classGreen = revisedCost > existingCost ? 'red-value form-control' :
                revisedCost < existingCost ? 'green-value form-control' : 'form-class';

            return (
                <span className={classGreen} title={checkForDecimalAndNull(revisedCost, getConfigurationKey().NoOfDecimalForPrice)}>
                    {checkForDecimalAndNull(revisedCost, getConfigurationKey().NoOfDecimalForPrice)}
                </span>
            );
        }

        // Use the value calculated by ageValueGetterLanded (passed as props.value)
        let totalCost = props.value;
        
        // If no value from valueGetter, calculate manually as fallback
        if (!totalCost && totalCost !== 0) {
            // 1. Calculate Basic Price (Basic Rate with percentage + Other Cost)
            let basicPrice = 0;
            
            // Priority 1: If percentage is applied, always use percentage calculation
            if (row?.Percentage && Number(row?.Percentage) !== 0) {
                // Apply percentage to original Basic Rate
                const originalBasicRate = Number(row?.BasicRatePerUOM || 0);
                const basicRateWithPercentage = originalBasicRate + (originalBasicRate * Number(row?.Percentage) / 100);
                basicPrice = basicRateWithPercentage + checkForNull(row?.NewOtherNetCost || 0);
                row.NewBasicrateFromPercentage = basicRateWithPercentage; // Store for backward compatibility
            } 
            // Priority 2: Use stored Basic Price if available (when no percentage)
            else if (row?.NewNetCostWithoutConditionCost !== null && row?.NewNetCostWithoutConditionCost !== undefined && row?.NewNetCostWithoutConditionCost !== 0) {
                basicPrice = Number(row?.NewNetCostWithoutConditionCost);
            }
            // Priority 3: Use manually entered Basic Rate (when no percentage)
            else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
                basicPrice = Number(row?.NewBasicRate) + checkForNull(row?.NewOtherNetCost || 0);
            } 
            // Priority 4: Use original Basic Rate
            else {
                basicPrice = Number(row?.BasicRatePerUOM || 0) + checkForNull(row?.NewOtherNetCost || 0);
            }
            
            // 2. Add Condition Cost
            let conditionCost = checkForNull(row?.NewNetConditionCost || 0);
            
            // 3. Add Freight and Shearing costs
            let freightAndShearing = 0;
            if (getConfigurationKey().IsShowFreightAndShearingCostFields) {
                freightAndShearing = checkForNull(row?.RMFreightCost || 0) + checkForNull(row?.RMShearingCost || 0);
            }
            
            // Net Cost = Basic Price + Condition Cost + Freight + Shearing (NO SCRAP RATE)
            totalCost = basicPrice + conditionCost + freightAndShearing;
        }
        
        const existingCost = checkForDecimalAndNull(row?.NetLandedCost || 0);
        const classGreen = totalCost > existingCost ? 'red-value form-control' :
            totalCost < existingCost ? 'green-value form-control' : 'form-class';

        let displayValue = checkForDecimalAndNull(totalCost, getConfigurationKey().NoOfDecimalForPrice);
        return <span className={classGreen} title={displayValue}>{displayValue}</span>
    }
    const NewBasicPriceFormmater = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const classGreen = ((checkForNull(row?.NewNetCostWithoutConditionCost) + checkForNull(checkForNull(row?.NewOtherNetCost))) > row?.NetCostWithoutConditionCost) ? 'red-value form-control' : (checkForNull(row?.NewNetCostWithoutConditionCost) + checkForNull(checkForNull(row?.NewOtherNetCost)) < row?.NetCostWithoutConditionCost) ? 'green-value form-control' : 'form-class'
        return showValue(row, classGreen, row?.NewNetCostWithoutConditionCost)
    }
    const revisedBasicRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text '>Revised {!isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"basicRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const revisedScrapRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text'>Revised {!isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"scrapRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const cancel = () => {
        list && list.map((item) => {
            item.NewBasicRate = undefined
            item.NewScrapRate = undefined
            return null
        })
        props.backToSimulation()
        // setShowMainSimulation(true)                    //RE
    }

    const closeDrawer = (e = '') => {
        setShowRunSimulationDrawer(false)

    }


    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        editable: true
    };

    const onGridReady = (params) => {
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        params.api.paginationGoToPage(0);
        setTimeout(() => {
            setShowTooltip(true)
        }, 100);
    };

    const onPageSizeChanged = (newPageSize) => {
        gridApi.paginationSetPageSize(Number(newPageSize));
    };

    const onFilterTextBoxChanged = (e) => {

        gridApi?.setQuickFilter(e?.target?.value);
        setTextFilterSearch(e?.target?.value)
    }
    const cellChange = (props) => {
        const rowData = props?.data;
        
        if (rowData && props.colDef && props.colDef.colId === 'Percentage') {
            
            // Update calculations when percentage changes
            let basicRateWithPercentage = 0; // Define outside if block to avoid scope issues
            
            if (rowData?.Percentage && Number(rowData?.Percentage) !== 0) {
                const originalBasicRate = Number(rowData?.BasicRatePerUOM || 0);
                basicRateWithPercentage = originalBasicRate + (originalBasicRate * Number(rowData?.Percentage) / 100);
                
                // Update NewBasicRate so Basic Rate Revised field shows percentage-affected value
                rowData.NewBasicRate = basicRateWithPercentage;
                
                // Also update Scrap Rate with percentage (for display only, won't affect Net Cost)
                const originalScrapRate = Number(rowData?.ScrapRate || 0);
                const scrapRateWithPercentage = originalScrapRate + (originalScrapRate * Number(rowData?.Percentage) / 100);
                rowData.NewScrapRate = scrapRateWithPercentage;
                
                // Calculate Basic Price = Basic Rate with percentage + Other Cost
                rowData.NewNetCostWithoutConditionCost = basicRateWithPercentage + checkForNull(rowData?.NewOtherNetCost || 0);
                
                // Calculate Net Cost = Basic Price + Condition Cost + Freight + Shearing (NO SCRAP RATE)
                const conditionCost = checkForNull(rowData?.NewNetConditionCost || 0);
                const freightAndShearing = getConfigurationKey().IsShowFreightAndShearingCostFields ? 
                    checkForNull(rowData?.RMFreightCost || 0) + checkForNull(rowData?.RMShearingCost || 0) : 0;
                
                rowData.NewNetLandedCost = rowData.NewNetCostWithoutConditionCost + conditionCost + freightAndShearing;
                

                
                // Also update the list array to ensure data persistence
                if (list && list[props.node.rowIndex]) {
                    list[props.node.rowIndex].NewBasicRate = basicRateWithPercentage;
                    list[props.node.rowIndex].NewScrapRate = rowData.NewScrapRate; // Include scrap rate
                    list[props.node.rowIndex].NewNetCostWithoutConditionCost = rowData.NewNetCostWithoutConditionCost;
                    list[props.node.rowIndex].NewNetLandedCost = rowData.NewNetLandedCost;
                    list[props.node.rowIndex].Percentage = rowData.Percentage;
                }
                
            } else if (rowData?.Percentage === 0 || rowData?.Percentage === '' || !rowData?.Percentage) {
                // Reset to original values when percentage is cleared
                basicRateWithPercentage = Number(rowData?.BasicRatePerUOM || 0); // Reset to original value
                rowData.NewBasicRate = undefined; // Clear the percentage-affected basic rate
                rowData.NewScrapRate = undefined; // Clear the percentage-affected scrap rate
                rowData.NewNetCostWithoutConditionCost = Number(rowData?.BasicRatePerUOM || 0) + checkForNull(rowData?.NewOtherNetCost || 0);
                
                // Recalculate Net Cost without percentage (NO SCRAP RATE)
                const conditionCost = checkForNull(rowData?.NewNetConditionCost || 0);
                const freightAndShearing = getConfigurationKey().IsShowFreightAndShearingCostFields ? 
                    checkForNull(rowData?.RMFreightCost || 0) + checkForNull(rowData?.RMShearingCost || 0) : 0;
                
                rowData.NewNetLandedCost = rowData.NewNetCostWithoutConditionCost + conditionCost + freightAndShearing;
                

                
                // Also update the list array
                if (list && list[props.node.rowIndex]) {
                    list[props.node.rowIndex].NewBasicRate = undefined;
                    list[props.node.rowIndex].NewScrapRate = undefined; // Clear scrap rate too
                    list[props.node.rowIndex].NewNetCostWithoutConditionCost = rowData.NewNetCostWithoutConditionCost;
                    list[props.node.rowIndex].NewNetLandedCost = rowData.NewNetLandedCost;
                    list[props.node.rowIndex].Percentage = rowData.Percentage;
                }
            }
            
            // Force refresh of all related columns, especially Basic Rate
            setTimeout(() => {
                if (gridApi) {
                    // First refresh specific columns that depend on percentage
                    gridApi.refreshCells({
                        rowNodes: [props.node],
                        columns: ['NewBasicRate', 'NewScrapRate', 'NewNetCostWithoutConditionCost', 'NewNetLandedCost'],
                        force: true
                    });
                    
                    // Then force complete row redraw
                    gridApi.redrawRows({ rowNodes: [props.node] });
                    
                    // Force state update to trigger component re-render
                    setBasicRate(rowData.NewBasicRate || 0);
                    
                    // Additional fix: Force DOM update for Basic Rate field
                    const basicRateElement = document.getElementById(`newBasicRate-${props.node.rowIndex}`);
                    if (basicRateElement) {
                        basicRateElement.textContent = basicRateWithPercentage.toFixed(2);
                    }
                }
            }, 150);
        }
    }

    const onCellValueChanged = (props) => {
        const rowData = props?.data
        
        if (rowData) {
            setBasicRate(rowData?.NewBasicRate)
            setNetCostWithoutConditionCost(rowData?.NewNetCostWithoutConditionCost)
        }
    }

    const handleEffectiveDateChange = (date) => {
        setEffectiveDate(date)
        setIsEffectiveDateSelected(true)
        setIsWarningMessageShow(false)
    }
    const EditableCallbackForPercentage = (props) => {
        const rowData = props?.data;
        let value = false
        if (!rowData?.NewBasicRate) {
            value = true
        } else {
            value = false
        }
        return value
    }
    const EditableCallbackForNewBasicRate = (props) => {
        const rowData = props?.data;
        let value = false
        if (rowData?.Percentage && Number(rowData?.Percentage) !== 0 && !rowData?.NewBasicRate) {
            value = false
        } else {
            value = true
        }
        setRowIndex(props?.node?.rowIndex)
        return value
    }

    const EditableCallbackForNewScrapRate = (props) => {
        const rowData = props?.data;
        let value = false
        if (rowData?.IsScrapUOMApply === 'No') {
            value = false
        } else {
            value = true
        }
        return value
    }

    const EditableCallbackForNewScrapRateSecond = (props) => {
        const rowData = props?.data;
        let value = false
        if (rowData?.IsScrapUOMApply === 'Yes') {
            value = false
        } else {
            value = true
        }
        return value
    }

    const ageValueGetterPer = (params) => {
        let row = params.data
        if (!row?.Percentage) {
            if (row?.NewBasicRate) {
                return 0
            }
            return row?.BasicRatePerUOM * 0;
        } else {
            return row?.Percentage
        }
    };

    const percentageFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        let cellValue = cell
        if (cell && cell > 100) {
            Toaster.warning("Percentage should be less than or equal to 100")
            list[props.rowIndex].Percentage = 0
            cellValue = 0
        }
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cellValue, props, 'Percentage')
        return (
            <>
                {
                    <span id={`percentage${props.rowIndex}`} className={`form-control ${row?.NewBasicRate ? 'disabled' : ''}`} >{cell && value ? Number(cellValue) : (row?.Percentage ? row?.Percentage : 0)} </span>
                }
            </>
        )
    }

    /**
     * @method hyphenFormatter
     */
    const hyphenFormatter = (props) => {
        const cellValue = props?.value;
        return cellValue ? cellValue : '-';
    }

    const otherCostDrawer = (value, row, index, type) => {

        setRowData(row)
        setBasicRate(row?.NewBasicRate)
        if (type === 'Old') {

            setOtherCostDetailForRow(row?.RawMaterialOtherCostDetails || [])
            setIsViewFlag(true)
            setEditIndex(index)
        } else {

            setOtherCostDetailForRow(isImpactedMaster ? row?.SimulationRawMaterialOtherCostDetailsList || [] : row?.NewRawMaterialOtherCostDetails || []);            // setIsViewFlag((isRunSimulationClicked || isApprovalSummary) ? true : false)
            setIsViewFlag(false)
            setEditIndex(index)
        }
        setOpenOtherCostDrawer(true)

    }

    const conditionCostDrawer = (value, row, index, type) => {
        setRowData(row)
        setBasicRate(row?.NewBasicRate)
        if (type === 'Old') {

            setConditionCostDetailForRow(row?.RawMaterialConditionsDetails || [])
            setIsViewFlag(true)
            setEditIndex(index)
        } else {

            setConditionCostDetailForRow(isImpactedMaster ? row?.SimulationRawMaterialConditionsDetails || [] : row?.NewRawMaterialConditionCostDetails || [])
            // setIsViewFlag((isRunSimulationClicked || isApprovalSummary) ? true : false)
            setIsViewFlag(false)
            setEditIndex(index)
        }
        setOpenConditionCostDrawer(true)

    }

    const calculateAndSave = (tableData, totalCostBase) => {
        setIsLoader(true)
        list[editIndex].NewOtherNetCost = totalCostBase
        list[editIndex].NewOtherNetCostConversion = totalCostBase
        list[editIndex].NewOtherNetCostLocalConversion = totalCostBase
        list[editIndex].NewRawMaterialOtherCostDetails = tableData
        list[editIndex].NewNetCostWithoutConditionCost = Number(list[editIndex].NewBasicRate) + checkForNull(totalCostBase); // Update this line
        setNetCostWithoutConditionCost(Number(list[editIndex].NewBasicRate) + checkForNull(totalCostBase)); // Update the state

        setTimeout(() => {
            setIsLoader(false)
        }, 100);
    }

    const calculateAndSaveCondition = (tableData, totalCostBase) => {

        setIsLoader(true)
        list[editIndex].NewNetConditionCost = totalCostBase
        list[editIndex].NewConditionNetCostConversion = totalCostBase
        list[editIndex].NewConditionNetCostLocalConversion = totalCostBase
        list[editIndex].NewRawMaterialConditionCostDetails = tableData
        setTimeout(() => {
            setIsLoader(false)
        }, 100);
    }

    const closeOtherCostDrawer = (type, tableData, totalCostCurrency, totalCostBase, RowIndex) => {
        if (type === 'Save') {
            calculateAndSave(tableData, totalCostBase)
        } else {
            // If canceling, revert to the original RawMaterialOtherCostDetails
            const originalDetails = list[editIndex]?.RawMaterialOtherCostDetails || [];
            setOtherCostDetailForRow(originalDetails);
        }
        setOpenOtherCostDrawer(false)
        setIsViewFlag(false)
        // setOtherCostDetailForRow([])
    }

    const closeConditionCostDrawer = (type, tableData, totalCostCurrency, conditionCost) => {

        if (type === 'save') {
            const newConditionCost = tableData.reduce((acc, item) => checkForNull(acc) + checkForNull(item?.ConditionCostPerQuantity || 0), 0);
            calculateAndSaveCondition(tableData, newConditionCost)
        } else {
            // If canceling, revert to the original RawMaterialOtherCostDetails
            const originalDetails = list[editIndex]?.RawMaterialConditionsDetails || [];
            setConditionCostDetailForRow(originalDetails);
        }
        setOpenConditionCostDrawer(false)
        setIsViewFlag(false)
        // setOtherCostDetailForRow([])
    }

    const existingOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        const value = beforeSaveCell(cell, props, 'otherCost')

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(Number(row?.OldOtherCost), getConfigurationKey().NoOfDecimalForPrice) :
                        <span title={cell && value ? Number(cell) : Number(row?.OldNetConditionCost)}>{cell && value ? checkForDecimalAndNull(Number(cell), getConfigurationKey().NoOfDecimalForPrice) : checkForDecimalAndNull(Number(row?.OtherNetCost), getConfigurationKey().NoOfDecimalForPrice)} </span>

                }
                {true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const existingConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell, props, 'otherCost')
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(Number(row?.OldNetConditionCost), getConfigurationKey().NoOfDecimalForPrice) :
                        <span title={cell && value ? Number(cell) : Number(row?.OldNetConditionCost)}>{cell && value ? checkForDecimalAndNull(Number(cell), getConfigurationKey().NoOfDecimalForPrice) : checkForDecimalAndNull(Number(row?.OldNetConditionCost), getConfigurationKey().NoOfDecimalForPrice)} </span>

                }
                {true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const revisedOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        const value = beforeSaveCell(cell, props, 'otherCost')
        const showValue = cell && value ? checkForDecimalAndNull(Number(cell), getConfigurationKey().NoOfDecimalForPrice) : checkForDecimalAndNull(Number(row?.OtherNetCost), getConfigurationKey().NoOfDecimalForPrice)

        const classGreen = (checkForDecimalAndNull(row?.NewOtherNetCost, getConfigurationKey().NoOfDecimalForPrice) > checkForDecimalAndNull(row?.OtherNetCost, getConfigurationKey().NoOfDecimalForPrice)) ? 'red-value form-control' : (checkForDecimalAndNull(row?.NewOtherNetCost, getConfigurationKey().NoOfDecimalForPrice) < checkForDecimalAndNull(row?.OtherNetCost, getConfigurationKey().NoOfDecimalForPrice)) ? 'green-value form-control' : 'form-class'
        setRowIndex(props?.node?.rowIndex)

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewOtherCost, getConfigurationKey().NoOfDecimalForPrice) :
                        <span title={showValue} className={`${classGreen} with-button`}>{showValue} </span>

                }
                {/* {!isCostingSimulation && <button */}
                {true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const revisedConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        const value = beforeSaveCell(cell, props, 'otherCost')
        const showValue = cell && value ? checkForDecimalAndNull(Number(cell), getConfigurationKey().NoOfDecimalForPrice) : checkForDecimalAndNull(Number(row?.NetConditionCost), getConfigurationKey().NoOfDecimalForPrice)
        const classGreen = (checkForDecimalAndNull(row?.NewNetConditionCost, getConfigurationKey().NoOfDecimalForPrice) > checkForDecimalAndNull(row?.NetConditionCost, getConfigurationKey().NoOfDecimalForPrice)) ? 'red-value form-control' : (checkForDecimalAndNull(row?.NetConditionCost, getConfigurationKey().NoOfDecimalForPrice) < checkForDecimalAndNull(row?.OldConditionNetCost, getConfigurationKey().NoOfDecimalForPrice)) ? 'green-value form-control' : 'form-class'
        setRowIndex(props?.node?.rowIndex)

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewNetConditionCost, getConfigurationKey().NoOfDecimalForPrice) :
                        <span title={showValue} className={`${classGreen} with-button`}>{showValue} </span>

                }
                {/* {!isCostingSimulation && <button */}
                {true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => ConditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const changeList = (value) => {
        setIsLoader(true)
        list && list?.map(item => {
            item.Percentage = value;
            return null;
        })
        setTimeout(() => {
            setIsLoader(false)
        }, 100);
    }
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            changeList(e.target.value);
        }
    };

    const percentageHeader = () => {
        let value = '';
        const onHandler = (e) => {
            value = e.target.value
        }
        return (<div>
            <input type="text" className="form-control ag-grid-input" onChange={onHandler} onKeyPress={handleKeyPress} onBlur={() => changeList(value)} />
        </div>
        )
    }

    const zeroFormatter = (props) => {
        const cellValue = checkForDecimalAndNull(props?.value, getConfigurationKey().NoOfDecimalForPrice);
        return (cellValue !== ' ' && cellValue !== null && cellValue !== '' && cellValue !== undefined) ? cellValue : '0';
    }

    const basicPriceFormatter = (props) => {
        const row = props?.data;
        let displayValue = 0;
        
        console.log('BasicPriceFormatter Debug:', {
            percentage: row?.Percentage,
            basicRatePerUOM: row?.BasicRatePerUOM,
            newBasicRate: row?.NewBasicRate,
            newOtherNetCost: row?.NewOtherNetCost,
            scrapRate: row?.ScrapRate,
            newScrapRate: row?.NewScrapRate,
            conditionCost: row?.NewNetConditionCost,
            storedBasicPrice: row?.NewNetCostWithoutConditionCost
        });
        
        // Priority 1: If percentage is applied, always recalculate (this overrides stored values)
        if (row?.Percentage && Number(row?.Percentage) !== 0) {
            const originalBasicRate = Number(row?.BasicRatePerUOM || 0);
            const basicRateWithPercentage = originalBasicRate + (originalBasicRate * Number(row?.Percentage) / 100);
            displayValue = basicRateWithPercentage + checkForNull(row?.NewOtherNetCost || 0);
            
            // Store the calculated value
            row.NewNetCostWithoutConditionCost = displayValue;
            
            console.log('Applied percentage calculation:', {
                originalBasicRate: originalBasicRate,
                percentage: row?.Percentage,
                basicRateWithPercentage: basicRateWithPercentage,
                otherCost: row?.NewOtherNetCost || 0,
                finalDisplayValue: displayValue
            });
        }
        // Priority 2: Check if we already have a calculated Basic Price stored (only when no percentage)
        else if (row?.NewNetCostWithoutConditionCost !== null && row?.NewNetCostWithoutConditionCost !== undefined && row?.NewNetCostWithoutConditionCost !== 0) {
            displayValue = Number(row?.NewNetCostWithoutConditionCost);
            console.log('Using stored Basic Price (no percentage):', displayValue);
        }
        // Priority 3: If manual NewBasicRate exists (without percentage)
        else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            displayValue = Number(row?.NewBasicRate) + checkForNull(row?.NewOtherNetCost || 0);
            console.log('Using manual basic rate (no percentage):', displayValue);
        }
        // Priority 4: Use original Basic Rate + Other Cost
        else {
            displayValue = Number(row?.BasicRatePerUOM || 0) + checkForNull(row?.NewOtherNetCost || 0);
            console.log('Using original basic rate:', displayValue);
        }
        
        // Always store the calculated value for consistency
        row.NewNetCostWithoutConditionCost = displayValue;
        

        
        const formattedValue = checkForDecimalAndNull(displayValue, getConfigurationKey().NoOfDecimalForPrice);
        return (formattedValue !== ' ' && formattedValue !== null && formattedValue !== '' && formattedValue !== undefined) ? formattedValue : '0';
    }

    const localConversionFormatter = (props) => {
        const cellValue = checkForNull(props?.value);
        return checkForDecimalAndNull(cellValue, getConfigurationKey().NoOfDecimalForPrice)
    }

    const frameworkComponents = {
        effectiveDateFormatter: effectiveDateFormatter,
        costingHeadFormatter: costingHeadFormatter,
        CostFormatter: CostFormatter,
        newScrapRateFormatter: newScrapRateFormatter,
        newScrapRateUOMFormatter: newScrapRateUOMFormatter,
        NewcostFormatter: NewcostFormatter,
        costFormatter: costFormatter,
        customNoRowsOverlay: NoContentFound,
        newBasicRateFormatter: newBasicRateFormatter,
        cellChange: cellChange,
        oldBasicRateFormatter: oldBasicRateFormatter,
        oldScrapRateFormatter: oldScrapRateFormatter,
        vendorFormatter: vendorFormatter,
        customerFormatter: customerFormatter,
        plantFormatter: plantFormatter,
        revisedBasicRateHeader: revisedBasicRateHeader,
        revisedScrapRateHeader: revisedScrapRateHeader,
        ageValueGetterPer: ageValueGetterPer,
        percentageFormatter: percentageFormatter,
        percentageHeader: percentageHeader,
        nullHandler: props.nullHandler && props.nullHandler,
        oldScrapRateFormatterPerScrapUOM: oldScrapRateFormatterPerScrapUOM,
        hyphenFormatter: hyphenFormatter,
        existingOtherCostFormatter: existingOtherCostFormatter,
        revisedOtherCostFormatter: revisedOtherCostFormatter,
        existingConditionCostFormatter: existingConditionCostFormatter,
        revisedConditionCostFormatter: revisedConditionCostFormatter,
        zeroFormatter: zeroFormatter,
        basicPriceFormatter: basicPriceFormatter,
        localConversionFormatter: localConversionFormatter

    };

    const ageValueGetterLanded = (params) => {
        let row = params.data
        let valueReturn = 0;
        
        // 1. Calculate Net Cost based on Basic Rate Revised value
        let netCost = 0;
        let basicRateToUse = 0;
        
        // Always calculate the basic rate fresh to ensure we get the latest value
        if (row?.Percentage && Number(row?.Percentage) !== 0) {
            // Calculate basic rate with percentage
            const originalBasicRate = Number(row?.BasicRatePerUOM || 0);
            basicRateToUse = originalBasicRate + (originalBasicRate * Number(row?.Percentage) / 100);

        } else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            // Use manually entered basic rate
            basicRateToUse = Number(row?.NewBasicRate);

        } else {
            // Use original basic rate
            basicRateToUse = Number(row?.BasicRatePerUOM || 0);

        }
        
        // Calculate net cost = basic rate + other cost
        netCost = basicRateToUse + checkForNull(row?.NewOtherNetCost || 0);
        
        // 2. Add Condition Cost
        let conditionCost = checkForNull(row?.NewNetConditionCost || 0);
        
        // 3. Add Freight and Shearing costs
        let freightAndShearing = 0;
        if (getConfigurationKey().IsShowFreightAndShearingCostFields) {
            freightAndShearing = checkForNull(row?.RMFreightCost || 0) + checkForNull(row?.RMShearingCost || 0);
        }
        
        // Net Cost = Basic Rate Revised + Other Cost + Condition Cost + Freight + Shearing (NO SCRAP RATE)
        valueReturn = netCost + conditionCost + freightAndShearing;



        return valueReturn;
    };


    const ageValueGetterScrapRate = (params) => {
        let row = params.data
        let valueReturn = ''
        if (row?.IsScrapUOMApply === 'Yes') {
            valueReturn = checkForDecimalAndNull(row?.NewScrapRatePerScrapUOM * row?.CalculatedFactor, getConfigurationKey().NoOfDecimalForPrice)
        } else {
            valueReturn = row?.NewScrapRate
        }
        return valueReturn
    }

    const closePopUp = () => {
        setShowPopup(false)
    }
    const onPopupConfirm = () => {
        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, effectiveDate, res => {
                setValueFunction(true, res);
            }))
        } else {
            setValueFunction(false, []);
        }
        setShowPopup(false)
    }
    const basicRatetooltipToggle = () => {
        setBasicRateViewTooltip(!basicRateviewTooltip)
    }
    const scrapRatetooltipToggle = () => {
        setScrapRateViewTooltip(!scrapRateviewTooltip)
    }

    const onBtExport = () => {
        if (String(props?.masterId) === String(RMIMPORT)) {
            return returnExcelColumn(RM_IMPACT_DOWNLOAD_EXCEl_IMPORT, list)
        } else {

            return returnExcelColumn(RM_IMPACT_DOWNLOAD_EXCEl, list)
        }
    };

    const returnExcelColumn = (data = [], TempData) => {
        let temp = []
        TempData && TempData.map((item) => {
            let excelItem = { ...item }
            excelItem.EffectiveDate = (excelItem?.EffectiveDate)?.slice(0, 10)
            excelItem.NewNetLandedCost = excelItem?.NewNetLandedCost ?? excelItem?.NetLandedCost
            excelItem.NewScrapRate = excelItem?.NewScrapRate ?? excelItem?.ScrapRate
            excelItem.BasicRatePerUOM = isImpactedMaster ? excelItem?.OldBasicRate : excelItem?.BasicRatePerUOM
            excelItem.ScrapRate = isImpactedMaster ? excelItem?.OldScrapRate : excelItem?.ScrapRate
            excelItem.OtherNetCost = isImpactedMaster ? (excelItem?.OldOtherCost ?? 0) : excelItem?.OtherNetCost
            excelItem.NewOtherNetCost = isImpactedMaster ? excelItem?.NewOtherCost : excelItem?.OtherNetCost
            excelItem.NetLandedCost = isImpactedMaster ? excelItem?.OldNetLandedCost : excelItem?.NetLandedCost
            excelItem.ExchangeRate = item.EntryType === "Import" ? item?.ExchangeRate : undefined;
            Object.keys(excelItem).forEach(key => {
                if (excelItem[key] === null || excelItem[key] === undefined || excelItem[key] === '') {
                    excelItem[key] = "-";
                }
            });

            temp.push(excelItem)
        })

        const hasNonZeroBasedCosting = TempData && TempData?.some(item => item?.CostingHead !== "Zero Based");
        if (hasNonZeroBasedCosting) {
            data = data?.filter(column => !['NetCostWithoutConditionCost', 'NewNetCostWithoutConditionCost', 'NetConditionCost', 'NewNetConditionCost'].includes(column.value));
        }

        if (isImpactedMaster) {
            data = data.filter(column => !['CostingHead', 'VendorName', 'DestinationPlantName', 'Category', 'TechnologyName'].includes(column.value));
        } else {
            data = data.filter(column => !['LocalCurrency', 'PreviousMinimum', 'PreviousMaximum', 'PreviousAverage', 'Minimum', 'Maximum', 'Average', 'NewRMNetLandedCostConversion', 'ExchangeRate', 'OldRMNetLandedCostConversion', 'NewNetLandedCostLocalConversion', 'OldNetLandedCostLocalConversion'].includes(column.value));
        }
        return (
            <ExcelSheet data={temp} name={'RM Data'}>
                {data && data.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
            </ExcelSheet>);
    }

    return (

        <div>
            <div className={`ag-grid-react ${props.customClass}`}>
                {!showverifyPage &&
                    // {(!showverifyPage && !showMainSimulation) &&                    //RE
                    <Fragment>
                        {showTooltip && !isImpactedMaster && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={basicRateviewTooltip} toggle={basicRatetooltipToggle} target={"basicRate-tooltip"} >{"To edit revised basic rate please double click on the field."}</Tooltip>}
                        {showTooltip && !isImpactedMaster && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={scrapRateviewTooltip} toggle={scrapRatetooltipToggle} target={"scrapRate-tooltip"} >{"To edit revised scrap rate please double click on the field."}</Tooltip>}
                        <Row>
                            <Col className="add-min-height mb-3 sm-edit-page">
                                <div className={`ag-grid-wrapper height-width-wrapper reset-btn-container ${(list && list?.length <= 0) || noData ? "overlay-contain" : ""}`}>
                                    <div className="ag-grid-header d-flex justify-content-between">
                                        <div className='d-flex align-items-center'>
                                            <input type="text" className="form-control mr-1 table-search" id="filter-text-box" value={textFilterSearch} placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                            <button type="button" className="user-btn float-right mr-3 Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                                                <div className="refresh mr-0"></div>
                                            </button>
                                            <ExcelFile filename={`${props.lastRevision ? 'Last Revision Data' : 'Impacted Master Data'}`} fileExtension={'.xls'} element={
                                                <button title="Download" type="button" className={'user-btn'} ><div className="download mr-0"></div></button>}>
                                                {onBtExport()}
                                            </ExcelFile>
                                        </div>
                                        <div className='d-flex justify-content-end'>

                                            <div className="d-flex justify-content-end bulk-upload-row rm-row" style={{ marginRight: 0 }}>
                                                {
                                                    isbulkUpload && <>
                                                        <div className="d-flex align-items-center">
                                                            <label>Rows with changes:</label>
                                                            <TextFieldHookForm
                                                                label=""
                                                                name={'NoOfCorrectRow'}
                                                                Controller={Controller}
                                                                title={titleObj.rowWithChanges}
                                                                control={control}
                                                                register={register}
                                                                rules={{ required: false }}
                                                                mandatory={false}
                                                                handleChange={() => { }}
                                                                defaultValue={''}
                                                                className=""
                                                                customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                                errors={errors.NoOfCorrectRow}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <label>Rows without changes:</label>
                                                            <TextFieldHookForm
                                                                label=""
                                                                name={'NoOfRowsWithoutChange'}
                                                                Controller={Controller}
                                                                title={titleObj.rowWithoutChanges}
                                                                control={control}
                                                                register={register}
                                                                rules={{ required: false }}
                                                                mandatory={false}
                                                                handleChange={() => { }}
                                                                defaultValue={''}
                                                                className=""
                                                                customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                                errors={errors.NoOfRowsWithoutChange}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </>}
                                                {!isImpactedMaster && list && <div className={`d-flex align-items-center simulation-label-container`}>
                                                    <div className='d-flex'>
                                                        <label>{technologyLabel}: </label>
                                                        <p className='technology ml-1' title={list[0]?.TechnologyName}>{list[0]?.TechnologyName}</p>
                                                    </div>
                                                    {list[0]?.CostingTypeId !== CBCTypeId && <div className='d-flex pl-3'>
                                                        <label className='mr-1'>{vendorLabel} (Code):</label>
                                                        <p title={list[0]?.VendorName}>{list[0]?.VendorName ? list[0]?.VendorName : list?.[0]?.[`${vendorLabel} (Code)`]}</p>

                                                    </div>}
                                                    <button type="button" className={"apply ml-2 back_simulationPage"} id="simulation-back" onClick={cancel} disabled={isDisable}> <div className={'back-icon'}></div>Back</button>
                                                </div>}
                                            </div>


                                        </div>

                                    </div>
                                    <div className="ag-theme-material p-relative" style={{ width: '100%' }}>
                                        {isLoader && <LoaderCustom />}
                                        {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found simulation-lisitng" />}
                                        {list &&
                                            ((render || isLoader) ? <LoaderCustom customClass="loader-center" /> : (<AgGridReact

                                                ref={gridRef}
                                                floatingFilter={true}
                                                style={{ height: '100%', width: '100%' }}
                                                defaultColDef={defaultColDef}
                                                domLayout='autoHeight'
                                                // columnDefs={c}
                                                rowData={list}
                                                pagination={true}
                                                paginationPageSize={defaultPageSize}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                loadingOverlayComponent={'customLoadingOverlay'}
                                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                suppressColumnVirtualisation={true}
                                                stopEditingWhenCellsLoseFocus={true}
                                                onCellValueChanged={onCellValueChanged}
                                                onFilterModified={onFloatingFilterChanged}
                                                enableBrowserTooltips={true}
                                            >
                                                {
                                                    !isImpactedMaster &&
                                                    <AgGridColumn minWidth={columnWidths.CostingHead} field="CostingHead" tooltipField='CostingHead' headerName="Costing Head" editable='false' cellRenderer={'costingHeadFormatter'}></AgGridColumn>
                                                }
                                                {<AgGridColumn minWidth={120} field="EntryType" headerName="Entry Type" cellRenderer={"hyphenFormatter"}></AgGridColumn>}
                                                <AgGridColumn minWidth={columnWidths.RawMaterialName} field="RawMaterialName" tooltipField='RawMaterialName' editable='false' headerName="Raw Material"></AgGridColumn>
                                                <AgGridColumn minWidth={columnWidths.RawMaterialGradeName} field="RawMaterialGradeName" tooltipField='RawMaterialGradeName' editable='false' headerName="Grade" ></AgGridColumn>
                                                <AgGridColumn minWidth={columnWidths.RawMaterialSpecificationName} field="RawMaterialSpecificationName" tooltipField='RawMaterialSpecificationName' editable='false' headerName="Spec"></AgGridColumn>
                                                <AgGridColumn minWidth={columnWidths.RawMaterialCode} field="RawMaterialCode" tooltipField='RawMaterialCode' editable='false' headerName='Code' cellRenderer='hyphenFormatter'></AgGridColumn>
                                                {!isImpactedMaster && <AgGridColumn minWidth={columnWidths.Category} field="Category" tooltipField='Category' editable='false' headerName="Category"></AgGridColumn>}
                                                {!isImpactedMaster && <AgGridColumn minWidth={columnWidths.TechnologyName} field="TechnologyName" tooltipField='TechnologyName' editable='false' headerName={technologyLabel} ></AgGridColumn>}
                                                {!isImpactedMaster && list[0]?.CostingTypeId !== CBCTypeId && <AgGridColumn minWidth={columnWidths.VendorCod} field="Vendor (Code)" tooltipField='Vendor (Code)' editable='false' headerName={`${vendorLabel} (Code)`} cellRenderer='vendorFormatter'></AgGridColumn>}
                                                {!isImpactedMaster && list[0]?.CostingTypeId === CBCTypeId && <AgGridColumn minWidth={columnWidths.CustomerName} field="CustomerName" tooltipField='CustomerName' editable='false' headerName="Customer (Code)" cellRenderer='customerFormatter'></AgGridColumn>}
                                                {!isImpactedMaster && <AgGridColumn minWidth={columnWidths.PlantCode} field="Plant (Code)" editable='false' headerName="Plant (Code)" tooltipField='Plant (Code)' cellRenderer='plantFormatter' ></AgGridColumn>}
                                                <AgGridColumn minWidth={columnWidths.UnitOfMeasurementName} field="UnitOfMeasurementName" tooltipField='UnitOfMeasurementName' editable='false' headerName="UOM"></AgGridColumn>
                                                {isScrapUOMApplyTemp && <AgGridColumn minWidth={150} field="ScrapUnitOfMeasurement" tooltipField='ScrapUnitOfMeasurement' editable='false' headerName="Scrap UOM" cellRenderer='hyphenFormatter'></AgGridColumn>}
                                                {costingAndPartNo && <AgGridColumn field="CostingNumber" tooltipField='CostingNumber' editable='false' headerName="Costing No" minWidth={columnWidths.CostingNumber}></AgGridColumn>}
                                                {costingAndPartNo && <AgGridColumn field="PartNumber" tooltipField='PartNumber' editable='false' headerName="Part No" minWidth={columnWidths.PartNumber}></AgGridColumn>}

                                                {/* {String(props?.masterId) === String(RMIMPORT) && <AgGridColumn field="Currency" tooltipField='Currency' editable='false' headerName="Currency" minWidth={140} ></AgGridColumn>} */}
                                                {(isImpactedMaster && String(props?.masterId) === String(RMIMPORT)) && <AgGridColumn field="ExchangeRate" tooltipField='ExchangeRate' editable='false' headerName="Existing Exchange Rate" minWidth={140} ></AgGridColumn>}
                                                {getConfigurationKey().IsSourceExchangeRateNameVisible && <AgGridColumn minWidth={120} field="ExchangeRateSourceName" headerName="Exchange Rate Source"></AgGridColumn>}
                                                <AgGridColumn field="Currency" headerName="Currency/Settlement Currency" minWidth={180} cellRenderer={"hyphenFormatter"}></AgGridColumn>
                                                {(isImpactedMaster || props?.lastRevision) && <AgGridColumn field="LocalCurrency" minWidth={120} headerName={"Plant Currency"} cellRenderer={"currencyFormatter"}></AgGridColumn>}

                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} headerName={
                                                    "Basic Rate (Currency)"

                                                } marryChildren={true} >
                                                    <AgGridColumn minWidth={120} cellRenderer='oldBasicRateFormatter' field={isImpactedMaster ? "OldBasicRate" : "BasicRatePerUOM"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OldBasicRate" : "BasicRatePerUOM"}></AgGridColumn>
                                                    <AgGridColumn minWidth={120} cellRenderer='newBasicRateFormatter' editable={isImpactedMaster ? false : EditableCallbackForNewBasicRate} onCellValueChanged='cellChange' field="NewBasicRate" headerName="Revised" colId='NewBasicRate' headerComponent={'revisedBasicRateHeader'}></AgGridColumn>
                                                </AgGridColumn>

                                                {!isImpactedMaster && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" headerName={"Percentage"} marryChildren={true} minWidth={240}>
                                                    <AgGridColumn minWidth={120} editable={EditableCallbackForPercentage} onCellValueChanged='cellChange' field="Percentage" colId='Percentage' valueGetter={ageValueGetterPer} cellRenderer='percentageFormatter' headerComponent={'percentageHeader'}></AgGridColumn>
                                                </AgGridColumn>}
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} marryChildren={true} headerName={
                                                    "Scrap Rate (Currency)"

                                                }>
                                                    {isScrapUOMApplyTemp && <AgGridColumn minWidth={columnWidths.ScrapRatePerScrapUOM} field={isImpactedMaster ? "OldScrapRatePerScrapUOM" : "ScrapRatePerScrapUOM"} editable='false' cellRenderer='oldScrapRateFormatterPerScrapUOM' headerName="Existing (In Scrap UOM)" colId={isImpactedMaster ? "ScrapRatePerScrapUOM" : "ScrapRatePerScrapUOM"} ></AgGridColumn>}
                                                    {isScrapUOMApplyTemp && <AgGridColumn minWidth={columnWidths.NewScrapRatePerScrapUOM} cellRenderer='newScrapRateUOMFormatter' field='NewScrapRatePerScrapUOM' headerName="Revised (In Scrap UOM)" colId={"NewScrapRatePerScrapUOM"} editable={isImpactedMaster ? false : EditableCallbackForNewScrapRate}></AgGridColumn>}
                                                    <AgGridColumn minWidth={120} field={isImpactedMaster ? "OldScrapRate" : "ScrapRate"} editable='false' cellRenderer='oldScrapRateFormatter' headerName="Existing" colId={isImpactedMaster ? "OldScrapRate" : "ScrapRate"} ></AgGridColumn>
                                                    <AgGridColumn minWidth={120} cellRenderer={'newScrapRateFormatter'} field="NewScrapRate" headerName="Revised" colId="NewScrapRate" valueGetter={ageValueGetterScrapRate} headerComponent={'revisedScrapRateHeader'} editable={isImpactedMaster ? false : EditableCallbackForNewScrapRateSecond} ></AgGridColumn>
                                                </AgGridColumn>
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={300} headerName={
                                                    "Other Cost (Currency)"

                                                } marryChildren={true} >
                                                    {/* <AgGridColumn minWidth={150} cellRenderer='existingOtherCostFormatter' field={isImpactedMaster ? "OtherNetCost" : 'isCostingSimulation' ? 'OldRawMaterialIndexationDetails.OtherNetCost' : "OtherNetCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OtherNetCost" : "OtherNetCost"} ></AgGridColumn>
                                                    <AgGridColumn minWidth={150} cellRenderer='revisedOtherCostFormatter' editable={false} onCellValueChanged='cellChange' field={'isCostingSimulation' ? 'NewRawMaterialIndexationDetails.OtherNetCost' : "NewOtherNetCost"} headerName="Revised" colId='NewOtherNetCost' headerComponent={'revisedBasicRateHeader'}></AgGridColumn> */}
                                                    <AgGridColumn minWidth={150} cellRenderer='existingOtherCostFormatter' field={"isImpactedMaster ? OldOtherCost : OtherNetCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OtherNetCost" : "OtherNetCost"} ></AgGridColumn>
                                                    <AgGridColumn minWidth={150} cellRenderer='revisedOtherCostFormatter' editable={false} onCellValueChanged='cellChange' field={isImpactedMaster ? "NewOtherCost" : "NewOtherNetCost"} headerName="Revised" colId='NewOtherNetCost' ></AgGridColumn>
                                                </AgGridColumn>
                                                {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && list[0]?.CostingTypeId === ZBCTypeId && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} headerName={
                                                    "Basic Price (Currency)"

                                                }>
                                                    {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && <AgGridColumn minWidth={columnWidths.NetCostWithoutConditionCost} field={isImpactedMaster ? 'OldNetCostWithoutConditionCost' : 'NetCostWithoutConditionCost'} cellRenderer={'zeroFormatter'} editable='false' headerName="Existing" colId='NetCostWithoutConditionCost'></AgGridColumn>}
                                                    {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && <AgGridColumn minWidth={columnWidths.NewNetCostWithoutConditionCost} field={isImpactedMaster ? "NewNetCostWithoutConditionCost" : "NewNetCostWithoutConditionCost"} cellRenderer={'basicPriceFormatter'} editable='false' headerName="Revised" colId='NewNetCostWithoutConditionCost'></AgGridColumn>}
                                                </AgGridColumn>}

                                                {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && list[0]?.CostingTypeId === ZBCTypeId && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={300} headerName={
                                                    "Condition Cost (Currency)"

                                                } marryChildren={true} >
                                                    {/* <AgGridColumn minWidth={150} cellRenderer='existingConditionCostFormatter' field={isImpactedMaster ? "NetConditionCost" : 'isCostingSimulation' ? 'OldRawMaterialIndexationDetails.NetConditionCost' : "NetConditionCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "NetConditionCost" : "NetConditionCost"} ></AgGridColumn>
                                                    <AgGridColumn minWidth={150} cellRenderer='revisedConditionCostFormatter' editable={false} onCellValueChanged='cellChange' field={'isCostingSimulation' ? 'NewRawMaterialIndexationDetails.NetConditionCost' : "NewNetConditionCost"} headerName="Revised" colId='NewNetConditionCost' headerComponent={'revisedBasicRateHeader'}></AgGridColumn> */}
                                                    <AgGridColumn minWidth={150} cellRenderer='existingConditionCostFormatter' field={isImpactedMaster ? "OldNetConditionCost" : "NetConditionCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "NetConditionCost" : "NetConditionCost"} ></AgGridColumn>
                                                    <AgGridColumn minWidth={150} cellRenderer='revisedConditionCostFormatter' editable={false} onCellValueChanged='cellChange' field={isImpactedMaster ? "NewNetConditionCost" : "NewNetConditionCost"} headerName="Revised" colId='NewNetConditionCost' ></AgGridColumn>
                                                </AgGridColumn>}

                                                {/* <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} headerName={"BOP Net Landed Cost Conversion"} marryChildren={true}>
                                                <AgGridColumn minWidth={120} field="OldRMNetLandedCostConversion" editable='false' cellRenderer={'hyphenFormatter'} headerName="Existing" colId='OldRMNetLandedCostConversion' suppressSizeToFit={true}></AgGridColumn>
                                                <AgGridColumn minWidth={120} field="NewRMNetLandedCostConversion" editable='false' cellRenderer={'hyphenFormatter'} headerName="Revised" colId='NewRMNetLandedCostConversion' suppressSizeToFit={true}></AgGridColumn>
                                            </AgGridColumn> */}
                                                {getConfigurationKey()?.IsShowFreightAndShearingCostFields && <AgGridColumn minWidth={columnWidths.RMFreightCost} field="RMFreightCost" tooltipField='RMFreightCost' editable='false' cellRenderer={'CostFormatter'} headerName="Freight Cost"></AgGridColumn>}
                                                {getConfigurationKey()?.IsShowFreightAndShearingCostFields && <AgGridColumn minWidth={columnWidths.RMShearingCost} field="RMShearingCost" tooltipField='RMShearingCost' editable='false' cellRenderer={'CostFormatter'} headerName="Shearing Cost" ></AgGridColumn>}
                                                {technologyId === String(FORGING) && <AgGridColumn minWidth={170} field="MachiningScrapRate" tooltipField='MachiningScrapRate' editable='false' headerName="Machining Scrap Rate" cellRenderer={'CostFormatter'}></AgGridColumn>}
                                                {<AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} headerName={
                                                    "Net Cost (Currency)"

                                                }>
                                                    <AgGridColumn minWidth={columnWidths.NetLandedCost} field="NetLandedCost" tooltipField='NetLandedCost' editable='false' cellRenderer={'costFormatter'} headerName="Existing" colId='NetLandedCost'></AgGridColumn>
                                                    <AgGridColumn minWidth={columnWidths.NewNetLandedCost} field="NewNetLandedCost" editable='false' valueGetter={ageValueGetterLanded} cellRenderer={'NewcostFormatter'} headerName="Revised" colId='NewNetLandedCost'></AgGridColumn>
                                                </AgGridColumn>
                                                }
                                                {/* THIS COLUMN WILL BE VISIBLE IF WE ARE LOOKING IMPACTED MASTER DATA FOR RMIMPORT */}
                                                {(isImpactedMaster || props?.lastRevision || (String(props?.masterId) === String(EXCHNAGERATE) || String(props?.masterId) === String(RMIMPORT))) && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} headerName={`Net Cost (Plant Currency)`}>
                                                    <AgGridColumn minWidth={120} field="OldNetLandedCostLocalConversion" tooltipField='OldRMNetLandedCostConversion' editable='false' headerName="Existing" colId='OldRMNetLandedCostConversion' cellRenderer='localConversionFormatter'></AgGridColumn>
                                                    <AgGridColumn minWidth={120} field="NewNetLandedCostLocalConversion" editable='false' headerName="Revised" colId='NewRMNetLandedCostConversion' cellRenderer='localConversionFormatter'></AgGridColumn>
                                                </AgGridColumn>
                                                }
                                                {props.children}
                                                <AgGridColumn minWidth={columnWidths.EffectiveDate} field="EffectiveDate" editable='false' cellRenderer={'effectiveDateFormatter'} headerName={props.isImpactedMaster && !props.lastRevision ? "Current Effective date" : "Effective Date"} ></AgGridColumn>
                                                <AgGridColumn field="RawMaterialId" hide></AgGridColumn>

                                            </AgGridReact>))}

                                        {<PaginationWrapper gridApi={gridApi} setPage={onPageSizeChanged} />}
                                    </div>
                                </div>

                            </Col>
                        </Row>
                        {
                            !isImpactedMaster &&
                            <Row className="sf-btn-footer no-gutters justify-content-between bottom-footer">
                                <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                                    <div className="inputbox date-section mr-3 verfiy-page simulation_effectiveDate">
                                        <DatePicker
                                            name="EffectiveDate"
                                            id="EffectiveDate"
                                            selected={DayTime(effectiveDate).isValid() ? new Date(effectiveDate) : ''}
                                            onChange={handleEffectiveDateChange}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode='select'
                                            dateFormat="dd/MM/yyyy"
                                            minDate={maxDate}
                                            placeholderText="Select effective date"
                                            className="withBorder"
                                            autoComplete={"off"}
                                            disabledKeyboardNavigation
                                            onChangeRaw={(e) => e.preventDefault()}
                                        />
                                        {isWarningMessageShow && <WarningMessage dClass={"error-message"} textClass={"pt-1"} message={"Please select effective date"} />}
                                    </div>
                                    <button onClick={verifySimulation} type="submit" id="verify-btn" className="user-btn mr5 save-btn verifySimulation" disabled={isDisable}>
                                        <div className={"Run-icon"}>
                                        </div>{" "}
                                        {"Verify"}
                                    </button>
                                </div>
                            </Row>
                        }
                    </Fragment>

                }
                {
                    openOtherCostDrawer &&
                    <AddOtherCostDrawer
                        isOpen={openOtherCostDrawer}
                        anchor={"right"}
                        closeDrawer={closeOtherCostDrawer}
                        rawMaterial={true}
                        rmBasicRate={basicRate}
                        ViewMode={isImpactedMaster || isViewFlag}
                        rmTableData={otherCostDetailForRow}
                        RowData={rowData}
                        plantCurrency={rowData?.Currency}
                        settlementCurrency={rowData?.Currency}
                        isImpactedMaster={isImpactedMaster}
                        disabled={isImpactedMaster}
                    />
                }
                {
                    getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && openConditionCostDrawer &&
                    <AddConditionCosting
                        isOpen={openConditionCostDrawer}
                        tableData={conditionCostDetailForRow}
                        closeDrawer={closeConditionCostDrawer}
                        anchor={'right'}
                        basicRateBase={netCostWithoutConditionCost}
                        ViewMode={isImpactedMaster || isViewFlag}
                        isFromMaster={true}
                        // isFromImport={states.isImport}
                        // EntryType={checkForNull(ENTRY_TYPE_DOMESTIC)}
                        currency={rowData?.Currency}
                        PlantCurrency={rowData?.Currency}
                        isImpactedMaster={isImpactedMaster}
                        disabled={isImpactedMaster}

                    />
                }
                {
                    showverifyPage &&
                    <VerifySimulation token={token} cancelVerifyPage={cancelVerifyPage} />
                }
                {
                    showPopup && <PopupMsgWrapper isOpen={showPopup} closePopUp={closePopUp} confirmPopup={onPopupConfirm} message={popupMessage} />
                }

                {
                    showRunSimulationDrawer &&
                    <RunSimulationDrawer
                        isOpen={showRunSimulationDrawer}
                        closeDrawer={closeDrawer}
                        anchor={"right"}
                    />
                }
            </div>
        </div>
    );
}


export default RMSimulation;
